// extracted by mini-css-extract-plugin
export default {"overlay":"loading-overlay_overlay__UBF5S","message":"loading-overlay_message__-MK1q"};